// // src/hooks/usePersonalOrdersByCustomerId.js

// import { useEffect, useState } from 'react';
// import axios from 'axios';

// const usePersonalOrdersByCustomerId = (customerId) => {
//   const [salesOrders, setSalesOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     if (!customerId) return;

//     const fetchPersonalOrders = async () => {
//       setLoading(true);
//       setError(null);

//       try {
//         const response = await axios.get('http://localhost:5000/api/zoho/personalorders', {
//           params: { customer_id: customerId },
//         });

//         if (response.data?.salesorders) {
//           setSalesOrders(response.data.salesorders);
//         } else {
//           setSalesOrders([]); // Reset to empty if no salesorders
//           setError(response.data?.message || 'No sales orders found.');
//         }
//       } catch (err) {
//         setError(err.message || 'Error fetching personal sales orders');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchPersonalOrders();
//   }, [customerId]);

//   return {
//     salesOrders,
//     loading,
//     error,
//   };
// };

// export default usePersonalOrdersByCustomerId;




import { useEffect, useState } from 'react';
import axios from 'axios';
import { base_url } from '../baseUrl';

const usePersonalOrdersByCustomerId = (customerId, orderId = null) => {
  const [salesOrders, setSalesOrders] = useState([]);
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [detailLoading, setDetailLoading] = useState(false);
  const [error, setError] = useState(null);
  const [detailError, setDetailError] = useState(null);

  useEffect(() => {
    if (!customerId) return;

    const fetchPersonalOrders = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(`${base_url}api/zoho/personalorders`, {
          params: { customer_id: customerId },
        });

        if (response.data?.salesorders) {
          setSalesOrders(response.data.salesorders);
        } else {
          setSalesOrders([]);
          setError(response.data?.message || 'No sales orders found.');
        }
      } catch (err) {
        setError(err.message || 'Error fetching personal sales orders');
      } finally {
        setLoading(false);
      }
    };

    fetchPersonalOrders();
  }, [customerId]);

  useEffect(() => {
    if (!orderId) {
      setOrderDetails(null);
      setDetailError(null);
      setDetailLoading(false);
      return;
    }

    const fetchOrderDetails = async () => {
      setDetailLoading(true);
      setDetailError(null);

      try {
        const response = await axios.get(`${base_url}api/zoho/salesorder/${orderId}`);
        setOrderDetails(response.data);
        console.log('Order details response:', response.data);
      } catch (err) {
        setDetailError(err.message || 'Error fetching sales order details');
      } finally {
        setDetailLoading(false);
      }
    };

    fetchOrderDetails();
  }, [orderId]);

  return {
    salesOrders,
    loading,
    error,
    orderDetails,
    detailLoading,
    detailError,
  };
};

export default usePersonalOrdersByCustomerId;
